module.exports = __webpack_public_path__ + "static/media/Setting.386ce7b3.svg";